import { FC } from 'react'
import styles from './vps-offer-card.module.scss'
import { useTranslation } from 'react-i18next'
import OfferCard from '../OfferCard'

type VpsOfferCardProps = {}

const VpsOfferCard: FC<VpsOfferCardProps> = ({}) => {
  const { t } = useTranslation()

  return (
    <OfferCard
      title={t('vps-vds-hosting')}
      button={{ text: t('more-details'), href: '/vps' }}
      bgClassName={styles.bg}
      bgSrc={'/img/bg/vps-vds-hosting.svg'}
    >
      {t('feature-vps-text')}
    </OfferCard>
  )
}

export default VpsOfferCard
